<template>
    <div>
        <DamagedHeader header="สินค้าชำรุดคืนไม่ได้รอย้ายเข้าคลังทิ้ง" :img_header="header_image" link_back="stock/storage/damagedstorage"/>
        <Damaged_drop/>
    </div>
</template>

<script>
    import HeaderImage from '@/assets/no-drugs.png'
    import DamagedHeader from "@/components/admin/stock/storage_damaged/header_damaged/DamagedHeader.vue";
    import Damaged_drop from "@/components/admin/stock/storage_damaged/Damaged_drop.vue";
    export default {
        name: "DropProduct",
        components: {
            Damaged_drop,
            DamagedHeader
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
